import React, { useState, useEffect } from "react";
import "./ImageSlider.css";
import Image1 from "../Images/p1.webp";
import Image2 from "../Images/p2.webp";
import Image3 from "../Images/p3.webp";
import Image4 from "../Images/p4.webp";
import Image5 from "../Images/p5.webp";
import Image6 from "../Images/p6.webp";
import Image7 from "../Images/p7.webp";
import Image8 from "../Images/p8.webp";
import Image9 from "../Images/p9.webp";
import Image10 from "../Images/p10.webp";
import Image11 from "../Images/p11.webp";
import Image12 from "../Images/p12.webp";

const ImageSlider = () => {
  const [visibleSlides, setVisibleSlides] = useState(3);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalAlt, setModalAlt] = useState("");
  const [slideDirection, setSlideDirection] = useState("right");
  const [currentModalIndex, setCurrentModalIndex] = useState(0);

  const images = [
    { src: Image1, alt: "نرم‌افزار 1" },
    { src: Image2, alt: "نرم‌افزار 2" },
    { src: Image3, alt: "نرم‌افزار 3" },
    { src: Image4, alt: "نرم‌افزار 4" },
    { src: Image5, alt: "نرم‌افزار 5" },
    { src: Image6, alt: "نرم‌افزار 6" },
    { src: Image7, alt: "نرم‌افزار 7" },
    { src: Image8, alt: "نرم‌افزار 8" },
    { src: Image9, alt: "نرم‌افزار 9" },
    { src: Image10, alt: "نرم‌افزار 10" },
    { src: Image11, alt: "نرم‌افزار 11" },
    { src: Image12, alt: "نرم‌افزار 12" },
  ];

  const getVisibleSlides = () => {
    const width = window.innerWidth;
    if (width >= 768) {
      return 3;
    } else if (width >= 480) {
      return 2;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setVisibleSlides(getVisibleSlides());
    };

    // اجرای اولیه
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalGroups = Math.ceil(images.length / visibleSlides);
  const maxSlide = (totalGroups - 1) * visibleSlides;

  const nextSlide = () => {
    setSlideDirection("right");
    setCurrentSlide(prev => Math.min(prev + visibleSlides, maxSlide));
  };

  const prevSlide = () => {
    setSlideDirection("left");
    setCurrentSlide(prev => Math.max(prev - visibleSlides, 0));
  };

  const openModal = (imgSrc, imgAlt, index) => {
    setModalImage(imgSrc);
    setModalAlt(imgAlt);
    setCurrentModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextModalImage = () => {
    if (currentModalIndex < images.length - 1) {
      setCurrentModalIndex(currentModalIndex + 1);
      setModalImage(images[currentModalIndex + 1].src);
      setModalAlt(images[currentModalIndex + 1].alt);
    }
  };

  const prevModalImage = () => {
    if (currentModalIndex > 0) {
      setCurrentModalIndex(currentModalIndex - 1);
      setModalImage(images[currentModalIndex - 1].src);
      setModalAlt(images[currentModalIndex - 1].alt);
    }
  };

  const visibleImages = images.slice(
    currentSlide,
    currentSlide + visibleSlides,
  );

  return (
    <div className="multi-slider-container">
      <div className="slider-controls">
        <button
          onClick={nextSlide}
          disabled={currentSlide >= images.length - visibleSlides}
          className="slider-arrow prev-arrow">
          ‹
        </button>

        <div className="slides-wrapper">
          <div className={`slides-group ${slideDirection}`}>
            {visibleImages.map((image, index) => (
              <div key={index} className="slide">
                <div
                  className="image-container"
                  onClick={() =>
                    openModal(image.src, image.alt, currentSlide + index)
                  }>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="slide-image"
                  />
                  <div className="hover-overlay">
                    <span className="hover-text">برای نمایش عکس کلیک کنید</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={prevSlide}
          disabled={currentSlide === 0}
          className="slider-arrow next-arrow">
          ›
        </button>
      </div>

      <div className="slider-dots">
        {Array.from({ length: totalGroups }).map((_, index) => (
          <span
            key={index}
            className={`dot ${
              currentSlide === index * visibleSlides ? "active" : ""
            }`}
            onClick={() => setCurrentSlide(index * visibleSlides)}
          />
        ))}
      </div>

      {isModalOpen && (
        <div className="image-slider-modal" onClick={closeModal}>
          <span
            className="image-slider-close"
            onClick={e => {
              e.stopPropagation();
              closeModal();
            }}>
            &times;
          </span>

          <button
            className="image-slider-modal-nav image-slider-modal-next"
            onClick={e => {
              e.stopPropagation();
              nextModalImage();
            }}
            disabled={currentModalIndex === images.length - 1}>
            ‹
          </button>

          <img
            className="image-slider-modal-content"
            src={modalImage}
            alt={modalAlt}
            onClick={e => e.stopPropagation()}
          />

          <button
            className="image-slider-modal-nav image-slider-modal-prev"
            onClick={e => {
              e.stopPropagation();
              prevModalImage();
            }}
            disabled={currentModalIndex === 0}>
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
